(() => {
const init = root => {
 if (root.dataset.everydayReady) return;
 root.dataset.everydayReady = 'true';
 const form = root.querySelector('[data-lgip-form]');
 if (!form) return;
 const dataNode = root.querySelector('[data-lgie-purchase-data]');
 if (!dataNode) return;
 const data = JSON.parse(dataNode.textContent);
 const variantInput = form.querySelector('[data-lgie-variant-id]');
 const add = form.querySelector('[data-lg-add]');
 const qty = form.querySelector('[name="quantity"]');
 const value = selector => form.querySelector(selector + ':checked')?.value || '';
 const norm = text => String(text || '').trim().toLowerCase();
 const storageURL = new URLSearchParams(location.search).get('storage');
 if (storageURL) {
  const requestedStorage = [...form.querySelectorAll('[data-lgie-storage]')].find(option => norm(option.value) === norm(storageURL));
  if (requestedStorage) requestedStorage.checked = true;
 }
 const currentVariant = () => data.variants.find(variant =>
  norm(variant.options[data.storageIndex]) === norm(value('[data-lgie-storage]')) &&
  (data.conditionIndex < 0 || norm(variant.options[data.conditionIndex]) === norm(value('[data-lgie-condition]'))) &&
  (data.colorIndex < 0 || norm(variant.options[data.colorIndex]) === norm(value('[data-lgie-color]')))
 );
 const ready = variant => !!(data.eligible && !data.preview && variant?.available && variant.price > 0 && value('[data-lgie-condition]') && value('[data-lgie-color]') && qty.checkValidity());
 const sync = () => {
  const variant = currentVariant();
  const allowed = ready(variant);
  const oldId = variantInput.value;
  variantInput.value = variant?.id || '';
  variantInput.disabled = !allowed;
  add.disabled = !allowed || document.querySelector('[data-lg-quick-cart]')?.getAttribute('aria-busy') === 'true';
  add.setAttribute('aria-disabled', String(!allowed));
  root.querySelector('[data-lgip-price]').textContent = variant?.price > 0 ? variant.formattedPrice : '—';
  root.querySelector('[data-lgie-price-note]').textContent = variant?.price > 0 ? 'For the selected configuration.' : 'Price to be confirmed.';
  const color = value('[data-lgie-color]');
  root.querySelector('[data-lgip-color-name]').textContent = color;
  const colorInput = form.querySelector('[data-lgie-color]:checked');
  const colorHandle = form.querySelector('[data-lgip-color-handle]');
  colorHandle.value = colorInput?.dataset.handle || '';
  colorHandle.disabled = !colorHandle.value;
  const payment = form.querySelector('[data-lgie-payment-live]');
  if (payment) { payment.hidden = !allowed; payment.inert = !allowed; }
  form.querySelector('[data-lgie-payment-placeholder]').hidden = allowed;
  root.querySelector('[data-lgie-status]').textContent = allowed ? 'Your selected phone is checked and documented before dispatch.' : !qty.checkValidity() ? 'Choose a whole-number quantity of at least 1.' : data.eligible ? 'This configuration is currently unavailable.' : 'Not currently available to purchase. Ask us to confirm price and availability.';
  const message = 'Hello Lambda Grove, I am interested in ' + root.dataset.phoneName + ', ' + value('[data-lgie-condition]') + ', ' + value('[data-lgie-storage]') + ', ' + color + ', quantity ' + qty.value + '. Please confirm price, availability and compatibility for my country, carrier and apps.';
  root.querySelectorAll('[data-lgie-enquiry]').forEach(link => { link.href = 'https://wa.me/85267603046?text=' + encodeURIComponent(message); });
  if (oldId !== variantInput.value && data.eligible && variant) {
   variantInput.dispatchEvent(new Event('change', {bubbles:true}));
   const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState(null, '', url);
  }
 };
 form.addEventListener('change', event => { if (event.target !== variantInput) sync(); });
 qty.addEventListener('input', sync);
 form.querySelectorAll('[data-lgie-step]').forEach(button => button.addEventListener('click', () => {
  if (!qty.value || !qty.checkValidity()) qty.value = '1';
  else if (Number(button.dataset.lgieStep) > 0) qty.stepUp();
  else qty.stepDown();
  qty.dispatchEvent(new Event('change', {bubbles:true}));
 }));
 form.addEventListener('submit', event => { if (!ready(currentVariant())) event.preventDefault(); });

    const main = root.querySelector('[data-lgip-main]');
    const stage = root.querySelector('[data-lgip-stage]');
    const thumbs = root.querySelector('.lgip-thumbs');
    const angleGallery = thumbs?.dataset.lgipAngleGallery === 'true';
    const showImage = button => {
      if (!main || !button) return;
      const responsiveSet = button.dataset.srcset;
      if (responsiveSet) {
        main.setAttribute('srcset', responsiveSet);
        main.setAttribute('sizes', button.dataset.sizes || '100vw');
      } else {
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
      }
      main.src = button.dataset.src;
      main.alt = button.dataset.alt;
      main.dataset.alpha = button.dataset.alpha || 'false';
      main.style.setProperty('--angle-scale', button.dataset.angleScale || '1');
      main.style.mixBlendMode = 'normal';
      thumbs.querySelectorAll('[data-lgip-thumbnail]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      stage.classList.toggle('is-product-view', button.dataset.view !== 'scene');
      stage.classList.toggle('is-detail-view', button.dataset.view === 'detail');
    };
    thumbs?.addEventListener('click', event => {
      const button = event.target.closest('[data-lgip-thumbnail]');
      if (button && thumbs.contains(button)) showImage(button);
    });
    const colors = [...root.querySelectorAll('[data-lgip-color]')];
    const selectColor = (option, updateUrl = true) => {
      if (!thumbs || !main) return;
      const template = angleGallery ? null : [...root.querySelectorAll('template[data-lgip-color-gallery]')].find(item => item.dataset.lgipColorGallery === option.dataset.handle);
      if (!angleGallery && !template) return;
      option.checked = true;
      root.querySelector('[data-lgip-color-name]').textContent = option.value;
      form.querySelector('[data-lgip-color-handle]').value = option.dataset.handle;
      if (!angleGallery) {
        stage.dataset.alpha = option.dataset.alpha;
        thumbs.replaceChildren(template.content.cloneNode(true));
        showImage(thumbs.querySelector('[data-lgip-thumbnail]'));
      }
      const specImage = root.querySelector('[data-lgip-spec-image]');
      if (specImage) {specImage.src = option.dataset.image; specImage.alt = option.dataset.alt; specImage.dataset.alpha = option.dataset.alpha;}
      if (updateUrl) {const url = new URL(location.href);url.searchParams.set('color',option.dataset.handle);history.replaceState(null,'',url);}
    };
    colors.forEach(option => option.addEventListener('change', () => {if(option.checked) selectColor(option);}));
    const requestedColor = colors.find(option => option.dataset.handle === new URL(location.href).searchParams.get('color'));
    if (requestedColor) selectColor(requestedColor, false);
    const dialog = root.querySelector('[data-lgip-lightbox]');
    root.querySelector('[data-lgip-zoom]')?.addEventListener('click', () => {
      if (!main || typeof dialog.showModal !== 'function') return;
      const image = dialog.querySelector('img'); image.src=main.src;image.alt=main.alt;dialog.showModal();
    });
    root.querySelector('[data-lgip-close]')?.addEventListener('click',()=>dialog.close());
    dialog?.addEventListener('click',event=>{ if(event.target === dialog){const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();} });
 sync();
};
document.querySelectorAll('.lgie-product').forEach(init);
document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('.lgie-product').forEach(init));
})();
